import { Link } from 'react-router-dom'

// Persistent landing footer (#7r2). Single navy strip — no distinct
// shade, mirroring marketing.
//
// Per dispatch overrides:
//  - "Community Guidelines" → /community-guidelines (app's existing
//    route, not marketing's /guidelines which doesn't exist in-app)
//  - Copyright year is auto-computed (marketing's hardcoded "2025"
//    is a maintenance bug, not a faithful-replica feature)

const FOOTER_LINKS: Array<{ label: string; to: string }> = [
  { label: 'Terms & Conditions',  to: '/terms' },
  { label: 'Privacy Policy',      to: '/privacy' },
  { label: 'Community Guidelines', to: '/community-guidelines' },
]

export function MarketingFooter() {
  const year = new Date().getFullYear()
  return (
    <footer className="bg-navy text-white py-6 px-4 text-center text-sm">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-2">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          {FOOTER_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-white/80 hover:text-gold outline-none focus-visible:underline transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </div>
        <p className="text-white/60 text-xs mt-1">
          © {year} Jnati. All rights reserved.
        </p>
      </div>
    </footer>
  )
}
